import { ActionTypes } from '../constants/index';

export const getUserUpdatedProfile = () => ({
  type: ActionTypes.USER_PROFILE_REQUEST,
});
